/* The home's About band (docs/mockups/telify-web/home-layouts.html, "1 Tighter"). Colors are theme tokens only. */
@layer telify {
  .grid {
    display: grid;
    grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
    gap: 72px;
    align-items: start;
  }

  .heading {
    margin: 20px 0 26px;
  }

  .prose p {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-secondary);
    max-width: 62ch;
  }

  .prose p:first-child {
    font-size: 19px;
    line-height: 1.6;
    color: var(--text-primary);
  }

  .prose p + p {
    margin-top: 16px;
  }

  /* The guide card: photo beside the studio's guide label, name and role; the bio full width below. */
  .guide {
    display: grid;
    grid-template-columns: 112px minmax(0, 1fr);
    gap: 22px 24px;
    align-items: center;
    padding: 28px;
    background: var(--tint);
    border: var(--line);
    border-radius: 6px;
  }

  /* Beside the story it starts level with the story's heading. */
  .besideStory {
    margin-top: 46px;
  }

  .noPhoto {
    grid-template-columns: minmax(0, 1fr);
  }

  .photo {
    aspect-ratio: 4 / 5;
    border-radius: var(--r-img);
    overflow: hidden;
    background: var(--bg-card);
  }

  .photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 30%;
  }

  .name {
    margin: 14px 0 4px;
    font-size: 28px;
  }

  .role {
    margin-top: 10px;
    font-size: 17px;
    color: var(--text-secondary);
  }

  .bio {
    grid-column: 1 / -1;
    margin-top: 2px;
    font-size: 15px;
    line-height: 1.65;
    color: var(--text-secondary);
  }

  .bio p + p {
    margin-top: 12px;
  }

  @media (max-width: 1023px) {
    .grid {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .besideStory {
      margin-top: 0;
    }
  }
}
